// extracted by mini-css-extract-plugin
export default {"hidden":"WinBox_hidden__0M92j","cursor":"WinBox_cursor__ANqvk","blink":"WinBox_blink__ZpA3I"};